import trackCTAClicked from './trackCTAClicked'

import type { Account } from '../../common/types'
import type {
  UpgradePathsTrackingEvents,
  TrackCTAClickedPayload,
} from './UpgradePathsTrackingTypes'

export default function UpgradePathsTracking(
  user: Account,
): UpgradePathsTrackingEvents {
  return {
    trackCTAClicked: ({
      cta,
      ctaButton,
      upgradePathName,
      ctaView,
      ctaLocation,
    }: TrackCTAClickedPayload): void =>
      trackCTAClicked({
        payload: {
          cta,
          ctaButton,
          upgradePathName,
          ctaView,
          ctaLocation,
        },
        user,
      }),
  }
}
